document.addEventListener("DOMContentLoaded", function () {
  const addToCartBtn = document.getElementById("elAddToCart");
  const variantSelector = document.querySelector(".el-variant-selector");

  if (!addToCartBtn) return;

  const defaultLabel =
    addToCartBtn.querySelector("[data-atc-label]")?.textContent ||
    "Add to cart";

  addToCartBtn.addEventListener("click", async function () {
    const labelEl = this.querySelector("[data-atc-label]");
    let selectedVariantId = null;
    let itemQty = null;

    if (variantSelector) {
      const checkedInput = variantSelector.querySelector(
        ".el-variant-radio:checked",
      );
      if (checkedInput) {
        selectedVariantId = checkedInput.value;
        itemQty = checkedInput.dataset.qty;
      }
    } else {
      selectedVariantId = addToCartBtn.dataset.defaultVariant;
      itemQty = 1;
    }

    if (!selectedVariantId) return;

    try {
      this.disabled = true;
      if (labelEl) labelEl.textContent = "Adding...";

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: selectedVariantId,
          quantity: itemQty,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to add to cart");
      }

      const data = await response.json();
      console.log("Added to cart:", data);

      if (labelEl) labelEl.textContent = "Added";

      setTimeout(() => {
        if (labelEl) labelEl.textContent = defaultLabel;
        this.disabled = false;
      }, 1500);
    } catch (error) {
      console.error(error);

      if (labelEl) labelEl.textContent = "Failed to add";

      setTimeout(() => {
        if (labelEl) labelEl.textContent = defaultLabel;
        this.disabled = false;
      }, 1500);
    }
  });
});
